module.exports = __webpack_public_path__ + "img/sDolphDive_350x350.59474959.jpg";